// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1EObo","disabled":"Button_disabled__GJhNJ"};